<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from '@/mixins/resize'


export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    options:{
      type:Object
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    options: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el)
      this.setOptions(this.options)
      // this.chart.setOption(options(this.options))
    },
    setOptions({courseName,count}={}){
      const animationDuration =3000
      this.chart.setOption({
    color: ['#F5B763'],
    tooltip: {
      trigger: 'axis',
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    grid: {
      left: 50,
      right: 50,
      bottom: 20,
      top: 85,
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      data: courseName,
      axisTick: {
        alignWithLabel: true
      },
      axisLine: {
        lineStyle: {
          width: 2,
          color: "rgba(255, 255, 255, 0.6)",
        }
      },
    }],
    yAxis: {
      type: 'value',
      axisTick: {
        show: false
      },
      axisLine: {
        show: false,
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
         color: "rgba(255, 255, 255, 0.6)",
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dotted',
          color: "rgba(255, 255, 255, 0.15)",
        }
      },
      minInterval: 1
    },
    series: [{
      type: 'bar',
      data: count,
      animationDuration,
      barWidth: 15,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#FFCF5F' },
          { offset: 1, color: 'rgba(255, 207, 95, 0.2)' },
        ]),
      }
    }]
      })
    }
  }
}
</script>
